export default "__VITE_ASSET__PygGEvKD__"